import '../_rollupPluginBabelHelpers-1f0bf8c2.js';
import { createComponent } from 'reakit-system/createComponent';
import { createHook } from 'reakit-system/createHook';
import 'reakit-utils/shallowEqual';
import 'react';
import 'reakit-utils/useForkRef';
import 'reakit-utils/useIsomorphicEffect';
import '../Role/Role.js';
import '../findEnabledItemById-8ddca752.js';
import '../__keys-6742f591.js';
import { b as COMBOBOX_GRID_ROW_KEYS } from '../__keys-0f89298f.js';
import '../Id/IdProvider.js';
import '../Id/Id.js';
import '../__keys-08a69d36.js';
import '../Group/Group.js';
import '../Composite/CompositeGroup.js';
import { unstable_useGridRow } from '../Grid/GridRow.js';

var unstable_useComboboxGridRow = createHook({
  name: "ComboboxGridRow",
  compose: unstable_useGridRow,
  keys: COMBOBOX_GRID_ROW_KEYS
});
var unstable_ComboboxGridRow = createComponent({
  as: "div",
  useHook: unstable_useComboboxGridRow
});

export { unstable_ComboboxGridRow, unstable_useComboboxGridRow };
